<script>
    import IconNote from '@/components/icon/IconNote.vue';
    import constants from '@/constants';

    export default {
        computed: {
            constants() {return constants}
        },
        components: {
            ButtonIcon: IconNote,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container"
        :to="{name: constants.ROUTER_NAME.CHANGELOG}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Changelog</label>
        </div>
    </router-link>
</template>